import { externalLink } from "./externalLink";

/** 外部リンクをnoreferrerオプションをつけて別タブで開く関数 */
export const windowOpen = (key: keyof typeof externalLink) => {
  if (typeof window !== "undefined") {
    window.open(externalLink[key], "_blank", "noreferrer");
  }
};
